const MS_TO_S = 1000;
const S_TO_M = 60;
const M_TO_H = 60;
const H_TO_D = 24;

/**
 * Format duration into d:hh:mm:ss format
 */
export default (duration: number): string => {
  duration = Math.floor(duration / MS_TO_S);
  /** Convert to seconds */
  const seconds = duration % S_TO_M;

  duration = Math.floor(duration / S_TO_M);
  /** Convert to minutes */
  const minutes = duration % M_TO_H;

  duration = Math.floor(duration / M_TO_H);
  /** Convert to hours */
  const hours = duration % H_TO_D;

  duration = Math.floor(duration / H_TO_D);
  /** Convert to days */
  const days = duration;
  const time: string[] = [];

  [days, hours, minutes, seconds].forEach((num) => {
    if (time.length || num) {
      time.push(num.toString().padStart(2, '0'));
    }
  });

  /**
   * Handle special case when there are only seconds, the format should be
   * 00:00
   */
  if (time.length === 1) {
    return time[0].padStart(5, '00:');
  }

  return time.join(':');
};
